<template>
  <div class="cus-filter-wrap">
    <select v-model="selected" class="cus-filter">
      <option v-for="(filterItem, index) in filterList" :key="filterItem.text + index" :data-filterObj="JSON.stringify(filterItem)"
              ref="filterData">{{filterItem.text}}</option>
    </select>
  </div>
</template>

<script>
import { findIndex, get } from 'lodash'
import { EventBus } from '@/components/eventbus/EventBus'
export default {
  name: 'FaqFilterListForDevice',
  props: {
    filteredFilterList: {
      type: Array
    },
    setFilterFn: {
      type: Function
    },
    filterText: {
      type: String
    }
  },
  data () {
    return {
      selected: '전체'
    }
  },
  computed: {
    filterList () {
      if (findIndex(this.filteredFilterList, { id: 'all', image: 'image', rank: '0', text: '전체' }) < 0) {
        let filterList = [{ id: 'all', image: 'image', rank: '0', text: '전체' }].concat(this.filteredFilterList)
        return filterList
      }
      return this.filteredFilterList
    }
  },
  created () {
    if (get(this.$route, ['query', 'filterId'], '') !== '') {
      let selectedData = this.filterList.filter((filter) => {
        if (filter.id === get(this.$route, ['query', 'filterId'], '')) {
          return filter
        }
      })
      this.selected = selectedData[0].text
    }
    EventBus.$on('selectedTitleChange', (filterText) => {
      this.selected = filterText
    })
  },
  watch: {
    selected () {
      const selectedOpt = this.$refs.filterData.filter(filter => filter.selected)[0].dataset.filterobj
      this.selected = JSON.parse(selectedOpt).text
      this.setFilterFn(JSON.parse(selectedOpt))
      EventBus.$emit('selectedTitleChange', JSON.parse(selectedOpt).text)
    }
  }
}
</script>
